import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import EPaperViewer from '../../components/EPaperViewer';
import EPaperCalendar from '../../components/EPaperCalendar';
import { getAllEPapers, getEPaperByDate, incrementEPaperView } from '../../firebase/firestore';
import { trackVisit } from '../../utils/trackVisit';
import { todayKey } from '../../utils/dateHelpers';
import './EPaperPage.css';

export default function EPaperPage() {
  const [allPapers, setAllPapers] = useState([]);
  const [currentPaper, setCurrentPaper] = useState(null);
  const [selectedDate, setSelectedDate] = useState(todayKey());
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    trackVisit({ pageType: 'epaper', pageURL: '/epaper' });
    getAllEPapers().then(papers => {
      setAllPapers(papers);
      loadPaper(todayKey(), papers);
    });
  }, []);

  // const loadPaper = async (date, papers = allPapers) => {
  //   const paper = papers.find(p => p.date === date) || await getEPaperByDate(date);
  //   setCurrentPaper(paper || null);
  //   setMessage(paper ? '' : `No E-Paper available for ${date}`);
  //   if (paper) {
  //     const key = `epaper_viewed_${paper.id}_${date}`;
  //     if (!sessionStorage.getItem(key)) {
  //       await incrementEPaperView(paper.id);
  //       sessionStorage.setItem(key, '1');
  //     }
  //   }
  //   setLoading(false);
  // };
  const loadPaper = async (date, papers = allPapers) => {
    const paper = papers.find(p => p.date === date) || await getEPaperByDate(date);
    setCurrentPaper(paper || null);
    setMessage(paper ? '' : `No E-Paper available for ${date}`);
    if (paper) {
      try {
        await incrementEPaperView(paper.id);
      } catch (e) {
        console.warn('EPaper view count update failed:', e);
      }
    }
    setLoading(false);
  };

  const handleDateSelect = (date, isAvailable) => {
    setSelectedDate(date);
    if (isAvailable) {
      setLoading(true);
      loadPaper(date);
    } else {
      setCurrentPaper(null);
      setMessage(`No E-Paper available for ${date}`);
    }
  };

  const availableDates = allPapers.map(p => p.date);

  return (
    <>
      <Navbar />
      <div className="epaper-header">
        <div className="container">
          <h1 className="epaper-page-title">📰 E-Paper</h1>
          <p>Digital edition of The Daily Herald</p>
        </div>
      </div>
      <main className="epaper-main">
        <div className="epaper-layout">
          <div className="epaper-viewer-col">
            {loading ? <div className="loading-spinner">Loading e-paper...</div>
              : message && !currentPaper
                ? <div className="epaper-not-available">
                  <div className="na-icon">📅</div>
                  <h3>Not Available</h3>
                  <p>{message}</p>
                  <p>Please select a highlighted date from the calendar.</p>
                </div>
                : <EPaperViewer epaper={currentPaper} />
            }
          </div>
          <aside className="epaper-aside">
            <EPaperCalendar availableDates={availableDates} onDateSelect={handleDateSelect} />
            <div className="epaper-info-box">
              <h4>📖 How to use</h4>
              <ul>
                <li>🟥 Red dates have e-papers</li>
                <li>🔍 Use +/- buttons to zoom</li>
                <li>◀▶ Navigate between pages</li>
                <li>⤢ Toggle fullscreen mode</li>
              </ul>
            </div>
            <div className="epaper-archive">
              <h4>Recent Editions</h4>
              {allPapers.slice(0, 7).map(p => (
                <button key={p.id} className={`archive-item ${p.date === selectedDate ? 'active' : ''}`}
                  onClick={() => handleDateSelect(p.date, true)}>
                  📰 {p.date}
                  <span>{p.viewCount || 0} views</span>
                </button>
              ))}
            </div>
          </aside>
        </div>
      </main>
      <Footer />
    </>
  );
}